import { useSyncExternalStore } from "react";

/** Global overlays opened from anywhere (header, palette, Home, rows). */
type UiState = {
  palette: boolean;
  deploy: { snapshot?: string } | null;
  feedback: boolean;
};

let state: UiState = { palette: false, deploy: null, feedback: false };
const listeners = new Set<() => void>();

export function setUi(patch: Partial<UiState>) {
  state = { ...state, ...patch };
  listeners.forEach((l) => l());
}

export function useUi() {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => state,
  );
}

export const openDeploy = (snapshot?: string) => setUi({ deploy: { snapshot }, palette: false });
export const openPalette = () => setUi({ palette: true });
export const openFeedback = () => setUi({ feedback: true, palette: false });
